import { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import API from '../../../service/api';
import { CustomModal } from '../../../components/CustomModal';
import { LoadingSpinner } from '../../../components/LoadingSpinner';
import { MDBBtn, MDBCheckbox } from 'mdb-react-ui-kit';
import { TextInput } from '../../../components/core/inputs/TextInput';

export interface AddMachineModalProps {
    locationId: number;
    open: boolean;
    onConfirm: (id: number) => void;
    onClose: () => void;
}
export const AddMachineModal = ({
    open,
    locationId,
    onClose,
    onConfirm,
}: AddMachineModalProps) => {
    const [selectedId, setSelectedId] = useState<number | null>(null);
    const [machines, setMachines] = useState<any[] | null>(null);
    const [search, setSearch] = useState('');
    const [showAll, setShowAll] = useState(false);
    const { t } = useTranslation();

    useEffect(() => {
        if (!open) return;

        setSearch('');
        setSelectedId(null);
        setShowAll(false);
        setMachines(null);
        API.GET(`/api/admlocations/${locationId}/notm`)
            .then((m) => setMachines(m))
            .catch((err) => alert(err.message));
    }, [open, locationId]);

    return (
        <CustomModal
            open={open}
            onClose={onClose}
            title={t('add_machine_to_location')}
            footer={
                <>
                    <MDBBtn color="secondary" onClick={onClose}>
                        {t('cancel')}
                    </MDBBtn>
                    <MDBBtn
                        color="primary"
                        disabled={selectedId == null}
                        onClick={() => onConfirm(selectedId ?? -1)}
                    >
                        {t('confirm')}
                    </MDBBtn>
                </>
            }
        >
            <div className="d-flex flex-column justify-content-center align-items-center">
                {machines == null && <LoadingSpinner />}
                {machines !== null && (
                    <div className="d-flex flex-column">
                        <TextInput
                            label={t('search')}
                            value={search}
                            onValueChange={setSearch}
                        />
                        <MDBCheckbox
                            label={t('show_all')}
                            type="checkbox"
                            checked={showAll}
                            onChange={(ev) =>
                                setShowAll(ev.currentTarget.checked)
                            }
                        />
                        <div
                            className="d-flex flex-column overflow-auto px-1 pt-2 pb-2"
                            style={{
                                maxHeight: 500,
                                minWidth: 300,
                                userSelect: 'none',
                            }}
                        >
                            {machines.map((m) => (
                                <div
                                    key={m.id}
                                    className={
                                        'flex-row align-items-center hover-shadow p-1' +
                                        (!showAll && m.location !== null
                                            ? ' d-none'
                                            : '')
                                    }
                                    style={{
                                        cursor: 'pointer',
                                        background:
                                            m.id == selectedId
                                                ? '#0000001a'
                                                : '',
                                        display:
                                            m.name
                                                .toLocaleUpperCase()
                                                .indexOf(
                                                    search.toLocaleUpperCase(),
                                                ) == '-1'
                                                ? 'none'
                                                : 'flex',
                                    }}
                                    onClick={() => setSelectedId(m.id)}
                                >
                                    <i className="fas fa-server text-primary" />
                                    <span className="ms-1">{m.name}</span>
                                    {m.location && (
                                        <span>
                                            &nbsp;(
                                            <i className="fas fa-map-marker-alt text-secondary fa-xs" />
                                            {m.location.Name})
                                        </span>
                                    )}
                                </div>
                            ))}
                        </div>
                    </div>
                )}
            </div>
        </CustomModal>
    );
};
